import type { SMSTemplateModel } from "./SMSTemplateModel";
import type {
  SMSCompanySettings,
  SMSPlaceholderDefinition,
  SMSProviderDefinition,
  SMSTemplate,
} from "./SMSTemplate.typed";

export class SMSTemplateAdapter {
  constructor(private model: SMSTemplateModel) {}

  listPlaceholders(): Promise<SMSPlaceholderDefinition[]> {
    return this.model.listPlaceholders();
  }

  listProviders(): Promise<SMSProviderDefinition[]> {
    return this.model.listProviders();
  }

  getSettings(): Promise<SMSCompanySettings> {
    return this.model.getSettings();
  }

  updateSettings(payload: Partial<SMSCompanySettings>): Promise<SMSCompanySettings> {
    return this.model.updateSettings(payload);
  }

  listTemplates(): Promise<SMSTemplate[]> {
    return this.model.listTemplates();
  }

  createTemplate(payload: SMSTemplate): Promise<SMSTemplate> {
    return this.model.createTemplate(payload);
  }

  updateTemplate(id: number, payload: SMSTemplate): Promise<SMSTemplate | void> {
    return this.model.updateTemplate(id, payload);
  }

  deleteTemplate(id: number): Promise<void> {
    return this.model.deleteTemplate(id);
  }
}
